var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { Mixins, Component, Prop } from 'vue-property-decorator';
import { PaymentMethod } from '../types/PaymentMethod';
import SingleSelectAccessible from '@/common/components/SingleSelectAccessible.vue';
import FilterInputRow from '@/common/components/FilterInputRow.vue';
import SortableHeaderButtonContent from '@/common/components/SortableHeaderButtonContent.vue';
import { RecordState } from '../types/RecordState';
import { AidTargetPaymentDataWrapper } from '../types/AidTargetPaymentDataWrapper';
import EntityService from '../services/EntityService';
import { Focusable } from '@/common/mixins/Focusable';
import { SortableTable } from '@/common/mixins/SortableTable';
import { getAriaSortValue } from '@/common/utils/accessibilityUtilities';
var PaymentTypeByTargetTable = /** @class */ (function (_super) {
    __extends(PaymentTypeByTargetTable, _super);
    function PaymentTypeByTargetTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entityService = new EntityService();
        _this.paymentKey = Date();
        _this.filterValue = "";
        _this.filteredPayments = [];
        _this.displayPayments = [];
        return _this;
    }
    PaymentTypeByTargetTable.prototype.mounted = function () {
        this.filteredPayments = this.paymentData;
        this.displayPayments = __spread(this.filteredPayments);
    };
    PaymentTypeByTargetTable.prototype.ariaSortValue = function (columnName, sortedBy, sortedAsc) {
        return getAriaSortValue(columnName, sortedBy, sortedAsc);
    };
    PaymentTypeByTargetTable.prototype.filter = function () {
        var _this = this;
        clearTimeout(this.filterTimer);
        var filter = this.filterValue.trim().length > 0 || this.filteredPayments != this.paymentData;
        if (filter) {
            this.filterTimer = setTimeout(function () {
                _this.filteredPayments = _this.paymentData.filter(function (x) {
                    return (x.aidTargetNumber != null && x["aidTargetNumber"].toLowerCase().includes(_this.filterValue.toLowerCase()))
                        || (x.aidTargetNumber != null && x["aidTargetNumber"].toLowerCase().replace(/\s/g, "").includes(_this.filterValue.toLowerCase()))
                        || (x.purpose != null && x["purpose"].toLowerCase().includes(_this.filterValue.toLowerCase()));
                });
                _this.displayPayments = _this.sortedAsc == null ? __spread(_this.filteredPayments) : _this.doSort(_this.filteredPayments);
            }, 300);
        }
    };
    PaymentTypeByTargetTable.prototype.createAndOpenERPR = function (paymentData) {
        return __awaiter(this, void 0, void 0, function () {
            var wrapper, aidTargetContext, id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        wrapper = new AidTargetPaymentDataWrapper(paymentData);
                        aidTargetContext = wrapper.aidTargetContext();
                        return [4 /*yield*/, this.entityService.createERPR(aidTargetContext)];
                    case 1:
                        id = _a.sent();
                        this.$router.push({ name: 'paymentRequestER', params: { id: id } });
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentTypeByTargetTable.prototype.showERPROption = function (paymentData) {
        var wrapper = new AidTargetPaymentDataWrapper(paymentData);
        return wrapper.showERPROption();
    };
    PaymentTypeByTargetTable.prototype.showERPRExistsAlready = function (paymentData) {
        return !this.showERPRStarted(paymentData)
            && (this.isPaymentRequestOpen(paymentData.paymentMethod, paymentData.expenseReportState)
                || this.isPaymentRequestOpen(paymentData.paymentMethod, paymentData.paymentRequestState));
    };
    PaymentTypeByTargetTable.prototype.showERPRStarted = function (paymentData) {
        return this.isPaymentRequestStarted(paymentData.paymentMethod, paymentData.expenseReportState)
            || this.isPaymentRequestStarted(paymentData.paymentMethod, paymentData.paymentRequestState);
    };
    PaymentTypeByTargetTable.prototype.showInsufficientFundsForAid = function (paymentData) {
        return paymentData.withdrawableAmount == 0
            && !this.isPaymentRequestOpen(paymentData.paymentMethod, paymentData.paymentRequestState);
    };
    PaymentTypeByTargetTable.prototype.showInvestmentBudgetaryEstimateStarted = function (paymentData) {
        return paymentData.hasOpenInvestmentBudgetaryEstimate;
    };
    PaymentTypeByTargetTable.prototype.showInvestmentFinalReportStarted = function (paymentData) {
        return paymentData.hasOpenInvestmentFinalReport;
    };
    PaymentTypeByTargetTable.prototype.isPaymentRequestStarted = function (paymentMethod, state) {
        return paymentMethod == PaymentMethod.PaymentRequest
            && (state == RecordState.New || state == RecordState.OpenInWeb);
    };
    PaymentTypeByTargetTable.prototype.isPaymentRequestOpen = function (paymentMethod, state) {
        return paymentMethod == PaymentMethod.PaymentRequest && state == RecordState.SentFromWeb;
    };
    __decorate([
        Prop({ type: Array, required: true }),
        __metadata("design:type", Array)
    ], PaymentTypeByTargetTable.prototype, "paymentData", void 0);
    PaymentTypeByTargetTable = __decorate([
        Component({
            name: 'PaymentTypeByTargetTable',
            components: {
                SingleSelectAccessible: SingleSelectAccessible,
                FilterInputRow: FilterInputRow,
                SortableHeaderButtonContent: SortableHeaderButtonContent
            }
        })
    ], PaymentTypeByTargetTable);
    return PaymentTypeByTargetTable;
}(Mixins(Focusable, SortableTable)));
export default PaymentTypeByTargetTable;
